<template>
  <div class="content">
    <div class="search-box justify-align">
      <img @click="onClickLeft" :src="require('../../assets/'+appTheme+'/right_icon2.png')" alt="" />
      <div class="search-box-sec left-justifying">
        <img :src="require('../../assets/'+appTheme+'/search_icon.png')" alt="" />
        <div class="searchInput" type="text" @click="onSearch">搜一搜 </div>
      </div>
    </div>
    <div class="content-cate">
      <van-tree-select :height="wh" :items="items" :main-active-index.sync="active" @click-nav="clickNav">
        <template #content>
          <div class="classify-box">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
              <van-swipe-item v-for="(item,k) in bannerList" :key="k" @click="clickDes(item.href)"><img class="cover-img" :src="item.image" /></van-swipe-item>
            </van-swipe>
            <!--          <img class="cover-img" v-if="currImg != ''" :src="currImg" />-->
            <div class="shop-box">
              <div class="shop-list">
                <van-list
                  v-model="loading"
                  :finished="finished"
                  :immediate-check="false"
                  :finished-text="finishedTxt"
                  @load="onLoadMore"
                >
                  <div class="shop-item left-justifying" v-for="(good,index) in giftGoods" :key="index">
                    <img class="shop-img" @click="goDesGood(good.id)" :src="good.image" alt="">
                    <div class="content-item">
                      <div class="title" @click="goDesGood(good.id)"> {{good.name}}</div>
                      <div class="item-bottom justify-align">
                        <div class="price" @click="goDesGood(good.id)">￥{{good.price}}</div>
                        <div class="rt-box left-justifying">
                          <img @click="shareClick(good)" :src="require('../../assets/'+appTheme+'/share_icon2.png')" alt="" />
                          <div class="btn" @click="goDesGood(good.id)">马上抢</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </van-list>

              </div>
            </div>
          </div>
        </template>
      </van-tree-select>
    </div>
    <!--    分享弹框-->
    <van-overlay :show="shareShow">
      <div class="wrapper" @click.stop>
        <div class="icon-box" @click="shareShowHide"><van-icon size="24" color="#fff" name="cross" /></div>
        <img v-if="posterUrl" class="poster-url" crossorigin="anonymous" :src="posterUrl" alt="" />
        <div class="imageWrapper" v-else id="imageWrapper" ref="imageTofile">
          <img class="img-goods goodsImg" :src="require('../../assets/'+appTheme+'/banner1.png')" alt="" />
          <div class="title">{{shareItem.name}}</div>
          <img ref="qrcode" class="qr-code-img" :src="qrcodeUrl" alt="" />
          <div class="hint">长按二维码保存图片</div>
        </div>


      </div>
    </van-overlay>
    <!-- 分享弹框end -->
    <div class="hidden" style="display: none;">
      <!--    width: 69.33333vw; height: 118.66667vw;-->
      <vue-canvas-poster v-if="qrcodeUrl" :widthPixels="1000" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
    </div>
  </div>
</template>


<script>
import QRCode from 'qrcode';
import { VueCanvasPoster } from 'vue-canvas-poster'
export default {
  name: "souvenirList",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      shareShow:false,
      searchValue: '',
      active: 0,
      items: [{id:1,text:'中山手信'}],
      currItem: '',
      curr: 0,
      wh:'500px',
      giftGoods:[],
      currImg:'',
      page:1,
      finishedTxt: '没有更多了~',
      currId:'',
      loading: false, // 加载动画 是否处于加载状态
      finished: false, // 是否已加载完成
      bannerList: [],
      qrcodeUrl: '', // 二维码
      shareItem: '',
      posterUrl:'', // 海报
      shareGoodsImg: '',
      painting:{
        width: '520px',
        height: '890px',
        background: '#ffffff',
        borderRadius: '10px'
      }
    }
  },
  components: {
    VueCanvasPoster
  },
  created() {
    var wh = document.documentElement.clientHeight
    this.wh = (wh-60) + 'px'
    this.getCategory()
    // this.getOnePayData()
    // this.getAd()
  },
  methods: {
    shareShowHide(){
      this.shareItem = ''
      this.shareGoodsImg = ''
      this.qrcodeUrl = ''
      this.shareShow = false
      console.log(this.qrcodeUrl)
      console.log('shareItem',this.shareItem)
    },
    shareClick(goods){ // 生成二维码
      console.log(goods)
      this.shareItem = goods
      this.shareGoodsImg = goods.image
      var id = goods.id
      let baseUrl = ''
      let http = window.location.protocol+'//'
      let url = window.location.hostname // 获取当前访问（域名）
      baseUrl = http+url+`/goodDetails?id=${id}`  //'https://jpzs-zst.itos.cn/goodDetails?id=750'
      console.log(baseUrl)
      let qrcodeUrl = baseUrl
      QRCode.toDataURL(qrcodeUrl, (err, qr) => {
        if (err) {
          this.$toast('生成二维码失败');
        } else {
          this.qrcodeUrl = qr;
          console.log(this.qrcodeUrl)
          this.shareShow = true
          // this.imageUrlToBase64(goods.image)
          // this.drawCanvas();
          this.drawPoster()
        }
      });

    },
    drawPoster(){
      console.log('shareItem',this.shareGoodsImg)
      var total = this.shareItem.price * 0.95
      var price = total.toFixed(2);
      var discount = '折后优惠价：'+price
      this.painting = {
        width: '520px',
        height: '890px',
        background: '#ffffff',
        borderRadius: '10px',
        views: [
          {
            type: 'rect',
            css: {
              width: '502px',
              height: '876px',
              right: '9px',
              bottom: '6px',
              borderRadius: '10px',
              borderWidth: '8px',
              color: '#ffffff',
              borderColor: '#FDD80D',
            }
          },
          {
            type: 'image',
            url: this.shareGoodsImg,// this.shareGoodsImg, // 'https://www.sunniejs.cn/static/avatar.png'
            css: {
              width: '370px',
              height: '370px',
              top: '30px',
              left: '75px'
            }
          },
          {
            type: 'text',
            text: this.shareItem.name,
            css: [
              {
                top: '430px',
                width: '400px',
                maxLines: 2,
                lineHeight: '50px',
                left: '60px',
                fontSize: '26px'
              }
            ]
          },
          {
            type: 'image',
            url: this.qrcodeUrl,
            css: {
              width: '170px',
              height: '170px',
              top: '530px',
              left: '175px'
            }
          },
          {
            type: "text",
            text: "长按二维码保存图片",
            css: {
              top: "720px",
              left: "136px",
              width: "360px",
              maxLines: 1,
              fontSize: "26px",
              color: '#E43A0D'
            }
          },
          // {
          //   type: 'rect',
          //   css: {
          //     width: '503px',
          //     height: '106px',
          //     right: '9px',
          //     bottom: '70px',
          //     color: '#feeb86',
          //
          //   }
          // },
          // {
          //   type: "text",
          //   text: "扫码购买立即享受95折",
          //   css: {
          //     bottom: "135px",
          //     left: "136px",
          //     width: "360px",
          //     maxLines:1,
          //     fontSize: "26px",
          //     color: '#E64D2A'
          //   }
          // },
          // {
          //   type: "text",
          //   text: discount, // 扫码购买立即享受95折 折后优惠价：15.2
          //   css: {
          //     bottom: "90px",
          //     left: "134px",
          //     width: "260px",
          //     maxLines:1,
          //     textAlign: 'center',
          //     fontSize: "26px",
          //     color: '#E64D2A'
          //   }
          // },
        ]
      }
    },
    //成功生成海报
    success(src) {
      this.posterUrl = src;
      // console.log(src)
    },
    fail(err) {
      // alert(err)
      console.log('fail', err)
    },
    drawCanvas() {
      let that = this;
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "正在合成海报",
      });
      setTimeout(() => {
        // DOM节点主体
        const canvas = document.createElement("canvas")
        let canvasBox = document.getElementById('imageWrapper')
        // const width = canvasBox.offsetWidth
        // const height = canvasBox.offsetHeight
        // canvas.width = width * 2
        // canvas.height = height * 2
        //useCORS允许网络地址图片跨域
        html2canvas(canvasBox, {
          backgroundColor: null,
          useCORS: true, // 【重要】开启跨域配置
          allowTaint: true,//允许跨域图片
          canvas: canvas,
          taintTest: false,//是否在渲染前测试图片
          scale: 2,
        }).then((canvas) => {
          var dataUrl = canvas.toDataURL("image/png", 1.0);
          // console.log(dataUrl); // +"?"+new Date().getTime();
          that.posterUrl = dataUrl;
          this.$toast.clear();
          this.$toast("生成成功,请长按保存");
        });
      }, 1500);
    },
    clickDes(url){ // 详情页
      console.log(url)
      var url = url
      if ( url != null){
        window.open(url)
      } else {
        console.log('kong')
      }
    },
    async getCategory() { // 获取左侧菜单
      var data = {
        type:'gift'
      }
      const res = await this.$Http.getGoodsCategories(data)
      console.log(res)
      if (res.code==200){
        var arr = res.data
        var arr = JSON.parse(JSON.stringify(arr).replace(/name/g,'text'))
        this.items = arr
        this.currItem = arr[0]
        this.currId =  arr[0].id
        this.currImg = this.items[0].banner
        this.bannerList =  this.items[0].banners
        this.getGoodListGift()
      } else {
        this.$toast(res.message)
      }
      // console.log(res)
    },
    async getGoodListGift () { // 手信列表
      var data ={
        type: 'gift',
        category_id:this.currId,
        page: 1
      }
      const res = await this.$Http.getGoodsList(data)
      if (res.code == 200){
        console.log('res',res.data.data)
        this.giftGoods = res.data.data
        // 加载状态结束
        this.loading = false;
        if (res.data.data.length == res.data.total){ // 数据全部加载完
          this.finished = true; // 数据全部加载完
          console.log('不加载')
          if(res.data.data == 0){
            this.finishedTxt = '暂无数据~'
          } else {
            this.finishedTxt = '没有更多了~'
          }
        }else {
          this.finished = false; // 不可以加载
        }

      } else {
        this.$toast(res.message)
      }
    },
    async onLoadMore(){ // more
      var that = this;
      this.page += 1;//页数+1
      var data ={
        // gift_goods: 1,
        type: 'gift',
        category_id:this.currId,
        page: this.page
      }
      const res = await this.$Http.getGoodsList(data)
      if (res.code == 200){
        console.log('res',res)
        var arr = that.giftGoods.concat(res.data.data);
        this.giftGoods = arr
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成
        if (this.giftGoods.length == res.data.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
      } else {
        this.$toast(res.message)
        this.$router.push('/');
      }
    },
    onClickLeft() {
      if (window.history.length <= 1) {
        this.$router.push('/');
        return false
      } else {
        this.$router.go(-1);
      }
    },
    clickNav(index){
      console.log(index)
      this.curr = index
      this.currItem = this.items[index]
      this.currImg = this.items[index].banner
      this.currId = this.items[index].id
      this.bannerList = this.items[index].banners
      this.giftGoods = []
      this.getGoodListGift()
    },
    onSearch(){
      this.$router.push({path:'/searchList',query:{type:'gift'}})
    },
    goDes(id){
      this.$router.push({path:'/classifyList',query: {id:id}})
    },
    goDesGood(gid,tid,isPay){ // 详情页
      this.$router.push({path:'/goodDetails',query:{id:gid,type:tid,isPay:isPay}})
    },
  }
}
</script>

<style lang="scss" scoped>
.imageWrapper{
  width: 520px;
  height: 890px;
  background: #FFFFFF;
  border: 6px solid #FDD80D;
  border-radius: 20px;margin: 0 auto;
  .title{
    padding: 0px 50px 0;font-size: 24px;
    color: #282828;
    line-height: 34px;
  }
  #canvas{
    width: 370px;
    height: 370px;
  }
  .img-goods{
    width: 370px;
    height: 370px;
    border-radius: 10px;margin: 30px auto;display: block;
  }
  .qr-code-img{
    width: 200px;
    height: 200px;display: block;margin: 0 auto;
  }
  .hint{
    font-size: 24px;color: #E43A0D;text-align: center;
  }
}
.wrapper{
  .icon-box{
    width: 630px;text-align: right;margin: 120px auto 30px;
  }
  .poster-url{
    width: 520px;
    height: 890px;display: block;margin: 0 auto;
  }
}
.my-swipe .van-swipe-item {
  width: 470px;
  height: 177px;
}
.van-tree-select__nav {
  webkit-box-flex: 0.75;
  -webkit-flex: 0.75;
  flex: 0.75;
}
.search-box{
  padding: 34px 42px 34px 27px;
  background: #FDD80D;
  img{
    width: 22px;height: auto;display: inline-block;
  }
  .search-box-sec{
    width: 590px;
    height: 60px;
    line-height: 60px;color: #8C8C8C;font-size: 24px;
    background: #FFFFFF;
    opacity: 0.63;
    border-radius: 30px;text-align: left;padding-left: 28px;
    img{
      width: 34px;height: auto;display: inline-block;
    }
    .searchInput{
      height: 60px;
      line-height: 60px;width: 500px;margin-left: 10px;border: none;background: none;color: #282828;font-size: 28px;
    }
  }
}
.van-sidebar-item--select::before {
  top: 0;height: 100%;
  background-color: #f7f8fa;width: 0px;
}
.van-tree-select{
  color: #282828;font-size: 30px;
}
.van-sidebar-item--select, .van-sidebar-item--select:active {
  font-size: 32px;font-weight: bold;
  font-weight: bold;border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  margin-left: 20px;
}
.classify-box{
  padding-top: 20px;
  .cover-img{
    width: 470px;
    height: 177px;
    border-radius: 12px;margin: 0 auto;
  }
}
.shop-box{
  font-size: 26px;
  .f-title-box{
    padding: 20px 24px;
    .f-title{
      text-align: left;font-size: 30px;color: #282828;
    }
    .f-title-right{
      font-weight: bold;
      color: #282828;font-size: 22px;
      span{
        color: #F23926;
      }
      img{
        margin-right: 10px;height: auto;display: block;width: 22px;
      }
    }
  }

  .shop-list{
    //-ms-flex-wrap: wrap;
    //flex-wrap: wrap;
    //display: -webkit-box;
    //display: -ms-flexbox;
    //display: flex;
    padding: 0 15px;
    .shop-item{
      text-align: center;padding-bottom: 38px;border-bottom: 1px solid #E8E8E7;margin-bottom: 10px;padding-top: 26px;
      img{
        width: 120px;
        height: 120px;
        border-radius: 10px;margin-right: 15px;
      }
      .content-item{
        width: 375px;
        .title{
          font-size: 24px;text-align: left;color: #000000;line-height: 40px;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          span{
            padding: 2px 5px;background: #F23926;
            border-radius: 5px;font-size: 18px;font-weight: bold;
            color: #FFFFFF;
          }
        }
        .item-bottom{
          .price{
            font-size: 26px;font-weight: bold;
            color: #F23926;
          }
          .rt-box{
            img{
              width: 29px;height: auto;display: inline-block;margin-right:25px;
            }
            .btn{
              background: #FDD80D;
              border-radius: 25px;font-size: 22px;padding: 8px 18px;
              font-weight: bold;
              color: #F23926;
            }
          }
        }
      }

    }
  }
}

</style>
